import { atom } from 'recoil';

interface ModalState {
  isOpen: boolean;
  component?: React.ReactNode | null;
}

export const modalState = atom<ModalState>({
  key: 'modalState',
  default: {
    isOpen: false,
  },
});
